export const sidebarLinks = (translation) => {
  return [
    {
      name: `${translation.sideMenu.Dashboard}`,
      url: '/dashboard',
      icon: 'sidebar-dashboard',
      modalLink: false,
    },
    {
      name: `${translation.sideMenu.Invoices}`,
      icon: 'sidebar-invoices',
      modalLink: false,
      isCollapsible: true,
      url: '',
      children: [
        {
          name: `${translation.sideMenu.Invoices_Drafts}`,
          url: '/invoices/drafts',
          icon: 'drafts',
          modalLink: false,
        },
        {
          name: `${translation.sideMenu.Invoices_Incomes}`,
          url: '/invoices/incomes',
          icon: 'incomes',
          modalLink: false,
        },
        {
          name: `${translation.sideMenu.Invoices_Expences}`,
          url: '/invoices/expenses',
          icon: 'expenses',
          modalLink: false,
        },
      ],
    },
    {
      name: `${translation.sideMenu.Last_Transactions}`,
      url: '/invoices/create',
      icon: 'sidebar-last-transactions',
      modalLink: false,
    },
    {
      name: `${translation.sideMenu.Reports}`,
      url: '/reports',
      icon: 'sidebar-reports',
      modalLink: false,
    },
    {
      name: `${translation.sideMenu.Instructions}`,
      url: '/instructions',
      icon: 'video',
      modalLink: false,
    },
  ];
};

export const sidebarAddLinks = (translation) => {
  return [
    {
      name: `${translation.sideMenu.Manager}`,
      url: '',
      icon: 'sidebar-new-manager',
      modalLink: true,
    },
    {
      name: `${translation.jobNumbers.Header}`,
      url: '',
      icon: 'sidebar-new-job',
      modalLink: true,
    },
    {
      name: `${translation.dashboard.PartnerButtonCr}`,
      url: '',
      icon: 'sidebar-new-manager',
      modalLink: true,
    },
    {
      name: `${translation.dashboard.PartnerButtonDr}`,
      url: '',
      icon: 'sidebar-new-manager',
      modalLink: true,
    },
  ];
};
